import styles from "./Designer.module.css";

/**
 * Paso "Cambiar detalles": el cliente elige, para cada parte del modelo que tiene variantes
 * de tipo de parte (master_part_type 7), cuál usar. Cada grupo es un radio (una sola opción activa).
 * Solo aparece cuando el modelo tiene al menos una variante tipo 7.
 */
const DesignerDetailsStepSection = ({ groups = [], onSelectVariant }) => {
    const hasGroups = Array.isArray(groups) && groups.length > 0;

    return (
        <div className={styles.detailsStep}>
            <div className={styles.detailsStepHead}>
                <h4 className={styles.detailsStepTitle}>Cambiar detalles</h4>
                <p className={styles.detailsStepSubtitle}>
                    Elegí cómo querés cada detalle de la prenda. Después vas a poder pintarla.
                </p>
            </div>

            {!hasGroups ? (
                <div className={styles.detailsEmpty}>
                    Este modelo no tiene detalles para cambiar. Podés continuar al siguiente paso.
                </div>
            ) : (
                <div className={styles.detailsGroups}>
                    {groups.map((group) => (
                        <div key={group.id} className={styles.detailsGroup}>
                            <div className={styles.detailsGroupHead}>
                                <span className={styles.detailsGroupTitle}>{group.parentLabel}</span>
                                {group.required ? (
                                    <span className={styles.detailsGroupRequired}>Requerido</span>
                                ) : null}
                            </div>
                            <div className={styles.detailsOptions}>
                                {group.options.map((option) => {
                                    const isActive = option.key === group.selectedKey;
                                    return (
                                        <button
                                            key={option.key}
                                            type="button"
                                            className={`${styles.detailsOption} ${
                                                isActive ? styles.detailsOptionActive : ""
                                            }`}
                                            aria-pressed={isActive}
                                            onClick={() => onSelectVariant?.(option.key)}
                                        >
                                            <span className={styles.detailsOptionThumb} aria-hidden="true">
                                                {option.icon ? (
                                                    <img src={option.icon} alt="" />
                                                ) : (
                                                    <i className="bi bi-scissors" />
                                                )}
                                            </span>
                                            <span className={styles.detailsOptionLabel}>{option.label}</span>
                                            {isActive ? (
                                                <span className={styles.detailsOptionCheck} aria-hidden="true">
                                                    <i className="bi bi-check-lg" />
                                                </span>
                                            ) : null}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DesignerDetailsStepSection;
